module.exports = __webpack_public_path__ + "static/img/55.c295e72b.svg";